var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accessdenied"},[_c('div',{staticClass:"img"}),_c('p',{staticClass:"text"},[_vm._v("暂无权限")])])}]

export { render, staticRenderFns }